import React, { Suspense } from 'react'
import { Redirect, Route } from 'react-router-dom'
import { ProtectedRoute } from '@organice/atoms/protectedRoute'
import { IRoute } from './config'
import { usePermissions } from '@organice/utils/hooks'

const RouteWithSubRoutes = (route: IRoute) => {
  const { belongsToGroup } = usePermissions()

  if (route.visibleOnlyToGroups && route.visibleOnlyToGroups.length > 0) {
    const hasAccess = route.visibleOnlyToGroups.some(groupName =>
      belongsToGroup({ name: groupName })
    )
    if (!hasAccess) {
      return <Redirect to="/" />
    }
  }

  return (
    <Suspense fallback={route.fallback}>
      {route.protected ? (
        <ProtectedRoute
          path={route.path}
          exact={route.exact}
          adminOnly={route.adminOnly}
          render={props => {
            return route.redirect ? (
              <Redirect to={route.redirect} />
            ) : (
              route.component && (
                <route.component {...props} routes={route.routes} />
              )
            )
          }}
        />
      ) : (
        <Route
          path={route.path}
          exact={route.exact}
          render={props => {
            return route.redirect ? (
              <Redirect to={route.redirect} />
            ) : (
              route.component && (
                <route.component {...props} routes={route.routes} />
              )
            )
          }}
        />
      )}
    </Suspense>
  )
}

export default RouteWithSubRoutes
